import { get } from '@kit/utils/APIV1.js'

export const slugs = async(podType) => {
  return get(`slugs/pod-type/${podType}`)
}
